var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex h-13" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-center bg-pure-white border-b border-l border-r border-slate-400 sticky left-0 z-10",
          class: { "rounded-bl": _vm.isLast }
        },
        [
          _c(
            "div",
            { staticClass: "px-4 flex flex-shrink-0 gap-2 bg-pure-white w-20" },
            [
              _c("BlTextBody2", {
                staticClass: "truncate text-slate-1000",
                attrs: { text: _vm.session.id }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "px-4 flex flex-shrink-0 gap-2 bg-pure-white w-50",
              attrs: { title: _vm.session.name }
            },
            [
              _c("BlTextBody2", {
                staticClass: "truncate text-slate-1000",
                attrs: { text: _vm.session.name || "Unnamed session" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "px-4 flex-shrink-0 bg-pure-white w-40 flex items-center border-b border-slate-400"
        },
        [
          _vm.session.appointment_id && _vm.session.status === "draft"
            ? _c("BlChip", { attrs: { chip: "scheduled" } })
            : _vm.session.status === "ongoing"
            ? _c("BlChip", { attrs: { chip: "in_progress" } })
            : _c("BlChip", { attrs: { chip: _vm.session.status } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "px-4 flex-shrink-0 bg-pure-white w-60 flex items-center border-b border-slate-400"
        },
        [
          _c("BlTextBody2", {
            attrs: { text: _vm.sessionAppointment.timeslot }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "px-4 flex-shrink-0 bg-pure-white w-50 flex items-center border-b border-slate-400"
        },
        [
          !_vm.session.appointment || !_vm.session.appointment.user
            ? _c("BlTextBody2", { attrs: { text: "-" } })
            : _c("BlTextBody2", {
                staticClass: "truncate",
                class: { "italic ": !_vm.session.appointment.user.name },
                attrs: {
                  title: _vm.session.appointment.user.name || "Deleted user",
                  text: _vm.session.appointment.user.name || "Deleted user"
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "px-4 flex-shrink-0 bg-pure-white w-40 flex items-center border-b border-slate-400"
        },
        [
          _c("BlTextBody2", {
            attrs: { text: _vm.session.number_of_measurements }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex sticky right-0 bg-pure-white flex-grow" },
        [
          _c(
            "div",
            {
              staticClass:
                "px-4 flex-shrink-0 bg-pure-white w-60 flex-grow flex items-center justify-end gap-2 border-b border-r border-slate-400",
              class: { "rounded-br": _vm.isLast }
            },
            [
              _vm.session.status === "draft" && !_vm.session.appointment_id
                ? _c("BlInputButton", {
                    attrs: { type: "outlined", dense: "", icon: "delete" },
                    on: {
                      clicked: function($event) {
                        _vm.deleteOpened = true
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.session.status === "draft"
                ? _c(
                    "router-link",
                    { attrs: { to: "/session/" + _vm.session.slug + "/edit" } },
                    [
                      _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          dense: "",
                          label: "Edit session"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.session.status === "draft"
                ? _c("BlInputButton", {
                    attrs: {
                      label: "Start session",
                      dense: "",
                      loading: _vm.launchLoading
                    },
                    on: { clicked: _vm.onStartSession }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.session.status === "ongoing"
                ? _c(
                    "router-link",
                    { attrs: { to: "/session/" + _vm.session.slug } },
                    [
                      _c("BlInputButton", {
                        attrs: { label: "Resume session", dense: "" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete the draft",
              description:
                "You are about to delete the session draft. Are you sure you want to proceed? This action is irreversible. ",
              label: "Delete",
              type: "error",
              empty: "",
              disabled: _vm.deleteLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onRemoveSession
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.launchBeforeTheTimeOpened
        ? _c("LaunchBeforeTheTimeModal", {
            attrs: { sessionAppointment: _vm.sessionAppointment },
            on: {
              "close-modal": function($event) {
                _vm.launchBeforeTheTimeOpened = false
              },
              "on-submit": _vm.onLaunchSession
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-064aac58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-064aac58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/session/DraftItem.vue
// module id = null
// module chunks = 